import { render, staticRenderFns } from "./ReplacementBillPreview.vue?vue&type=template&id=12016c6e&"
import script from "./ReplacementBillPreview.vue?vue&type=script&lang=js&"
export * from "./ReplacementBillPreview.vue?vue&type=script&lang=js&"
import style0 from "./ReplacementBillPreview.vue?vue&type=style&index=0&id=12016c6e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports